import { DKLogo } from './design/DKLogo';
import { brand, fontFamily } from '../theme/tokens';

/**
 * Coming Soon placeholder rendered in production until the full app launches.
 * Activated via the `VITE_COMING_SOON=true` env var (set in GitHub Actions
 * workflow → Cloudflare Pages deploy).
 *
 * Intentionally has zero side effects:
 *   - no SDK init / Telegram detection
 *   - no API calls
 *   - no router
 *   - no auth gate
 *
 * The page must render cleanly even outside Telegram (anyone who finds the
 * URL just sees the teaser, no errors).
 */
export function ComingSoon() {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '32px 24px',
        textAlign: 'center',
        // Soft brand gradient — same family as the Mini App's brand color
        // but lighter so the wordmark reads against it.
        background:
          'radial-gradient(ellipse at top, rgba(255,107,157,0.18) 0%, transparent 60%), #FBF7F8',
        fontFamily,
        color: '#1A1117',
      }}
    >
      <div style={{ position: 'relative', marginBottom: 24 }}>
        <div
          style={{
            position: 'absolute',
            inset: -16,
            borderRadius: '50%',
            background: brand.gradient,
            opacity: 0.18,
            filter: 'blur(28px)',
          }}
        />
        <div style={{ position: 'relative' }}>
          <DKLogo size={120} />
        </div>
      </div>

      <h1
        style={{
          margin: 0,
          fontSize: 32,
          fontWeight: 800,
          letterSpacing: -0.6,
          background: brand.gradient,
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text',
        }}
      >
        DreamKisses
      </h1>

      <p
        style={{
          marginTop: 12,
          marginBottom: 0,
          fontSize: 16,
          fontWeight: 600,
          color: '#1A1117',
        }}
      >
        Launching soon
      </p>

      <p
        style={{
          marginTop: 8,
          marginBottom: 0,
          fontSize: 14,
          color: 'rgba(60,40,50,0.65)',
          maxWidth: 320,
          lineHeight: 1.5,
        }}
      >
        AI-generated kiss videos from two photos. Watch this space.
      </p>
    </div>
  );
}
